import dynamic from 'next/dynamic';
import { PLUGIN_NAME, COMPONENT_PREFIX } from './constants';

export default async function load(app) {
  app.events.once('load:custom:page-builder:component', addComponent => {
    addComponent({
      key: `${COMPONENT_PREFIX}registrationform`,
      component: dynamic(
        () =>
          import(
            /* webpackChunkName: "blazePbNmRegistrationForm" */ './components/RegistrationForm'
          )
      )
    });
    addComponent({
      key: `${COMPONENT_PREFIX}userdetails`,
      component: dynamic(
        () => import(/* webpackChunkName: "blazePbPpUserDetails" */ './components/UserDetails')
      )
    });
  });

  return {
    name: PLUGIN_NAME
  };
}

load.pluginName = PLUGIN_NAME;
